<template>
  <v-dialog v-model="dialog" width="600px">
    <v-card>
      <v-card-title class="white--text primary text-uppercase"
        >Nhắc nhở sau tiết học
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-form ref="form" class="pa-6">
        <v-textarea
          v-model="classReminderInput"
          class="required"
          :rules="[$rules.required]"
          label="Nhắc nhở của Giáo viên"
          hide-details="auto"
          outlined
        ></v-textarea>
      </v-form>

      <v-divider></v-divider>
      <v-row class="px-6 pb-6 mt-6" no-gutters>
        <v-btn class="px-6" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="px-6" depressed color="primary" @click="save">Lưu</v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { get } from 'lodash'

export default {
  components: {},
  props: {
    state: Boolean,
    classReminder: String
  },
  data() {
    return {
      dialog: false,
      loading: false,
      classReminderInput: get(this.slot, 'classNote.data.classReminder', '')
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('ClassNoteDetail', ['slot']),
    ...mapGetters('ClassNoteDetail', ['classNoteDetailData'])
  },

  methods: {
    ...mapActions('ClassNoteDetail', ['updateClassReminder']),
    async save() {
      if (!this.$refs.form.validate()) return

      this.$loading.active = true
      try {
        await this.updateClassReminder({
          ...this.classNoteDetailData,
          data: {
            classReminder: this.classReminderInput
          }
        })

        this.$alert.updateSuccess()
        this.dialog = false
      } catch (error) {
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    },
    classReminder: {
      handler(val) {
        this.classReminderInput = val
      },
      immediate: true
    }
  }
}
</script>
